import { ComponentProps } from 'react';
import { DocumentDetailFilterResponse } from '@mercator-gcp/types/elastic_search_service/documents/DocumentDetailFilterResponse';
import Table from 'components/layout/Table';
import TableBody from 'components/widgets/DocumentSearch/Table/Body';
import TableHeader from 'components/widgets/DocumentSearch/Table/Header';

const tableStyle = {
  border: 'none',
  overflowX: 'unset',
  overflowY: 'unset',
  width: '100%',
  minWidth: '1080px',
  tableLayout: 'fixed',
};

type Props = ComponentProps<typeof Table> & {
  documentList?: DocumentDetailFilterResponse['results'];
  isLoading: boolean;
};

const CompanySearchTable = ({ documentList, isLoading, ...props }: Props) => {
  if (!documentList && !isLoading) {
    return null;
  }

  return (
    <Table sx={tableStyle} aria-label="company search results table" {...props}>
      <TableHeader />
      <TableBody items={documentList} isLoading={isLoading} />
    </Table>
  );
};

export default CompanySearchTable;
